<template>
    <nav class="menu-top">
        <ul :class="ulClass">
            <li>
                <a href="#" class="city d-flex align-items-center" @click.prevent="toggleCity()">
                    <span class="ic icon-baloon"></span>
                    <span class="city-container">{{ $store.state.city?.name }}</span>
                </a>
            </li>
            <li v-for="link in links">
                <inertia-link @click="hideCat()" :href="link.url">{{ link.text }}</inertia-link>
            </li>
        </ul>
    </nav>
</template>

<script setup>

import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useStore } from "vuex";
import useCityDropdown from "@/frontend/Composables/useCityDropdown";
import { hideCat } from "@/frontend/Composables/useHideCat";

const {toggleCityDropdown} = useCityDropdown()

const page = usePage();
const store = useStore();

const props = defineProps({
    ulClass: String
})

const links = computed(() => page.props?.layout?.menus?.header?.items || store.state?.layout?.menus?.header?.items);


const toggleCity = () => {
    const cityOpen = document.body.classList.contains("city-open")
    toggleCityDropdown(!cityOpen);
}

</script>

<style scoped>

</style>
